import React, { Component } from 'react';
import { string, func, shape, arrayOf } from 'prop-types';
import { FormControl, MenuItem, Select } from '@material-ui/core/index';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import styles from './styles.scss';

const muiTheme = createTheme({
  overrides: {
    MuiSvgIcon: {
      root: {
        fontSize: '16px'
      }
    }
  }
});
export const LOCATION_GRANULARITY = 'location_granularity';

export const locationGranularityType = shape({
  id: string,
  location_granularity_level: string,
  locations: arrayOf(string),
  location_granularity_label: string
});

export default class LocationGranularity extends Component {
  static propTypes = {
    title: string,
    description: string,
    data: arrayOf(locationGranularityType),
    locationGranularityLabel: string,
    selectedLocationGranularityId: string,
    onChange: func
  };

  static defaultProps = {
    title: 'Location Granularity',
    description:
      'Set the maximum level of granularity for Campaign Location geo reports.',
    locationGranularityLabel: 'Maximum level of location granularity'
  };

  handleLocationLevelChange = event => {
    const { onChange } = this.props;
    const selectedLocationId = event.target.value;
    onChange &&
      onChange({
        setting_name: LOCATION_GRANULARITY,
        setting_value: [selectedLocationId]
      });
  };

  render() {
    const {
      selectedLocationGranularityId,
      title,
      description,
      locationGranularityLabel,
      data
    } = this.props;

    return (
      <div className={styles.locationContainer}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>
        <div className={styles.locationLevelLabelContainer}>
          <MuiThemeProvider theme={muiTheme}>
            <div className={styles.labelContainer}>
              <span className={styles.locationGranularityLabel}>
                {locationGranularityLabel}
              </span>
            </div>
            <div className={styles.locationGranularitySelector}>
              <FormControl className={styles.dropDownForm}>
                <Select
                  value={selectedLocationGranularityId}
                  className={styles.selector}
                  onChange={this.handleLocationLevelChange}
                >
                  {data &&
                    data.map(item => {
                      return (
                        <MenuItem value={item.id} key={item.id}>
                          {item.location_granularity_label}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
          </MuiThemeProvider>
        </div>
      </div>
    );
  }
}
